import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OptionsRoutingModule } from './options-routing.module';
import { UserbalanceComponent } from './userbalance/userbalance.component';
import { OptionService } from './option.service';
import { MatspinnerComponent } from './matspinner/matspinner.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LayoutModule } from '@angular/cdk/layout';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTableModule } from '@angular/material/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserslistComponent } from './users/userslist/userslist.component';
import { AdduserComponent } from './users/adduser/adduser.component';
import { UsersService } from './users/users.service';
import { TranslateModule } from '@ngx-translate/core';
import { MessagesComponent } from './messages/messages.component';
import { ProfileComponent } from './profile/profile.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { SystemDataComponent } from './system-data/system-data.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomersComponent } from './customers/customers.component';
import { AddmandoobComponent } from './mandoobs/addmandoob/addmandoob.component';
import { MandoobslistComponent } from './mandoobs/mandoobslist/mandoobslist.component';
import { MandoobService } from './mandoobs/mandoob.service';
import { MandoobsBallanceComponent } from './mandoobs-ballance/mandoobs-ballance.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { SelectCheckAllComponent } from './select-check-all/select-check-all.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AddCustomerComponent } from './add-customer/add-customer.component';
import { PermNotificationsComponent } from './perm-notifications/perm-notifications.component';
import { SendSMSComponent } from './send-sms/send-sms.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ListInfoComponent } from './otherinfo/list-info/list-info.component';
import { InfoformComponent } from './otherinfo/infoform/infoform.component';
import { NgxSummernoteModule } from 'ngx-summernote';
import { MatMenuModule } from '@angular/material/menu';
import { GoodcardintcInterceptor } from '../goodcardintc.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DirectChargeOrdersComponent } from './direct-charge-orders/direct-charge-orders.component';

@NgModule({
  declarations: [UserbalanceComponent, MatspinnerComponent, AdduserComponent, UserslistComponent,
    MessagesComponent, ProfileComponent, ChangepasswordComponent, SystemDataComponent, CustomersComponent,
    AddmandoobComponent, MandoobslistComponent, MandoobsBallanceComponent, NotificationsComponent,
    SelectCheckAllComponent, AddCustomerComponent, PermNotificationsComponent, SendSMSComponent,
    ListInfoComponent, InfoformComponent, DirectChargeOrdersComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OptionsRoutingModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    LayoutModule,
    MatIconModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatPaginatorModule,
    MatGridListModule,
    MatTableModule,
    MatCheckboxModule,
    NgxWebstorageModule.forRoot(),
    TranslateModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    NgxSummernoteModule,
    MatMenuModule
  ],
  exports: [
    MatSelectModule, MatCheckboxModule, SelectCheckAllComponent
  ],
  providers: [OptionService, UsersService, MandoobService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GoodcardintcInterceptor,
      multi: true
    },
  ]
})
export class OptionsModule { }
